import { render, staticRenderFns } from "./MasterCargoType.vue?vue&type=template&id=701a7da9&scoped=true"
import script from "./MasterCargoType.vue?vue&type=script&lang=js"
export * from "./MasterCargoType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701a7da9",
  null
  
)

export default component.exports